import Navbar from 'components/Navbar';

import SettingSidebar from 'components/Navbar/SettingsSidebar';
import React from 'react';
import { NAV_BAR_HEIGHT_REM } from 'utils/dimensions';
import EntityHeader from './EntityHeader';
import EntityTable from './EntityTable';

const EntityList: React.FC = () => {
  const warningBarOffset =
    document != null &&
    document.getElementById != null &&
    document.getElementById('customer-warning')?.offsetHeight;

  return (
    <div
      className="flex flex-col min-w-screen bg-white overflow-hidden"
      style={{
        height: `calc(100vh - ${warningBarOffset}px)`,
      }}
    >
      <Navbar />
      <div
        className="flex flex-row"
        style={{
          height: `calc(100vh - ${warningBarOffset}px - ${NAV_BAR_HEIGHT_REM}rem)`,
        }}
      >
        <SettingSidebar />
        <div className="pb-6 flex flex-col gap-2 h-full w-full overflow-hidden">
          <EntityHeader />

          <EntityTable />
        </div>
      </div>
    </div>
  );
};

export default EntityList;
